export default "__VITE_ASSET__1KT6T_63__"